// src/components/PermissionGate.tsx
import React from 'react';
import { hasPermission } from '../utils/permissions';

interface PermissionGateProps {
  user: any; // 🚨 기존 'role' 대신 'user' 객체 전체를 받도록 변경!
  action: string; 
  children: React.ReactNode;
}

const PermissionGate: React.FC<PermissionGateProps> = ({ user, action, children }) => {
  // '최종판정' 확인 로직 (user 전체를 넘겨서 검사)
  const isAllowed = hasPermission(user, action);
  
  // 권한 문제생기면 콘솔로 확인
  // console.log(`🛡️ [권한검증] 유저:${user?.name} | 열쇠:${action} | 판정:${isAllowed ? '✅통과' : '❌차단'}`);

  if (isAllowed) {
    return <>{children}</>;
  }
  
  return null; 
};

export default PermissionGate;